let toaster: any

export const registerToast = (t: any) => {
  toaster = t
}

export const toastError = (msg: string) =>
  toaster?.error && toaster.error(msg)

export const toastSuccess = (msg: string) =>
  toaster?.success && toaster.success(msg)


